import {
  Box,
  Grid,
  Typography,
  TableCell,
  TableRow,
  Autocomplete,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select
} from '@mui/material';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Table from '../../../components/Table';
import { Company } from '../../../schema/company';
import { PersonType } from '../../../schema/person';
import { TableResponse } from '../../../schema/helper';
import { api } from '../../../api';
import { MenuItem } from '@mui/material';

interface EmergencyRolePerson {
  id: number;
  personnal_id: string;
  employee_code: string;
  full_name: string;
  person_type_id: number;
  company_id: number;
  person_type: PersonType;
  company: Company;
  status_id: number;
  status: string;
}

interface EmergencyInfoTable {
  emergencyRoleId: number | string | null;
  isCounting?: boolean | null;
}

const EmergencyInfoTable = ({ emergencyRoleId, isCounting }: EmergencyInfoTable) => {
  const [filterID, setFilterID] = useState<string>('');
  const [filterName, setFilterName] = useState<string>('');
  const [filterCompanyIDList, setFilterCompanyIDList] = useState<string[]>([]);
  const [filterStatusID, setFilterStatusID] = useState<string>('');

  const [searchCompanyKeyword, setSearchCompanyKeyword] = useState<string>('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [companies, setCompanies] = useState<Company[]>([]);
  const [data, setData] = useState<TableResponse<EmergencyRolePerson> | null>(null);
  const handlePageChange = (_: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    if (emergencyRoleId != null) {
      const searchParams = new URLSearchParams();
      if (filterID) {
        searchParams.set('personal_id', `${filterID}`);
      }
      if (filterName) {
        searchParams.set('name', `${filterName}`);
      }
      if (filterCompanyIDList.length) {
        filterCompanyIDList.forEach((company_id) => {
          searchParams.append('company_id', `${company_id}`);
        });
      }
      if (filterStatusID.length) {
        searchParams.set('status_id', `${filterStatusID}`);
      }
      searchParams.set('offset', `${page * rowsPerPage}`);
      searchParams.set('limit', `${rowsPerPage}`);

      // if (isCounting) {
        // searchParams.set('has_area', `${true}`);
      // }
      api
        .get<TableResponse<EmergencyRolePerson>>(`/emergency/role/${emergencyRoleId}/person`, {
          params: searchParams
        })
        .then((res) => {
          const { data } = res;
          setData(data);
        });
    }
  }, [
    emergencyRoleId,
    filterID,
    filterName,
    filterCompanyIDList,
    filterStatusID,
    page,
    rowsPerPage,
    isCounting
  ]);
  // useEffect(() => {
  //   api.get<Company[]>(`/company`).then((res) => {
  //     const { data } = res;
  //     setCompanies(data);
  //   });
  // }, []);
  useEffect(() => {
    if (searchCompanyKeyword == '') {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('limit', '10');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanies(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
    if (searchCompanyKeyword) {
      const timeOut = setTimeout(() => {
        const searchParams = new URLSearchParams();
        searchParams.set('company_name', searchCompanyKeyword);
        searchParams.set('limit', '10');

        api.get<Company[]>(`/company`, { params: searchParams }).then((res) => {
          const { data } = res;
          setCompanies(data);
        });
      }, 500);
      return () => clearTimeout(timeOut);
    }
  }, [searchCompanyKeyword]);
  return (
    <>
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="ค้นหาเลขบัตรประชาชน/รหัสพนักงาน"
              variant="outlined"
              placeholder="ค้นหาเลขบัตรประชาชน/รหัสพนักงาน"
              onChange={(event) => setFilterID(event.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete="off"
            />
          </Grid>
          <Grid item md={3}>
            <TextField
              id="search-text-label"
              label="ค้นหาชื่อ - นามสกุล"
              variant="outlined"
              placeholder="ค้นหาชื่อ - นามสกุล"
              onChange={(event) => setFilterName(event.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              autoComplete={'off'}
            />
          </Grid>
          <Grid item md={3}>
            <Autocomplete
              multiple
              loading
              limitTags={2}
              disablePortal
              options={companies}
              getOptionLabel={(option) => option.company_name}
              renderInput={(params) => <TextField {...params} label="บริษัท" fullWidth />}
              onChange={(_, value) =>setFilterCompanyIDList(value.map((data) => data.id.toString()))}
              onInputChange={(_, newInputValue) => {setSearchCompanyKeyword(newInputValue); }}
              fullWidth
            />
          </Grid>
          <Grid item md={3}>
            <FormControl fullWidth>
              <InputLabel>{`สถานะ`}</InputLabel>
              <Select
                label={`สถานะ`}
                variant="outlined"
                onChange={(event) => setFilterStatusID(event.target.value)}
                value={filterStatusID}
                autoComplete="off"
              >
                <MenuItem value="" defaultChecked>
                  ทั้งหมด
                </MenuItem>
                <MenuItem value="1">รายงานตัวแล้ว</MenuItem>
                <MenuItem value="0">ยังไม่รายงานตัว</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Table
          heads={['เลขบัตรประชาชน/รหัสพนักงาน', 'ชื่อ สกุล', 'บริษัท', 'สถานะ']}
          count={data?.total ? data?.total : 0}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        >
          {data?.data.map((item, index) => (
            <TableRow key={index}>
              <TableCell align="center">{(item.employee_code ? item.employee_code : item.personnal_id)}</TableCell>
              <TableCell align="center">{item.full_name}</TableCell>
              <TableCell align="center">{item.company.company_name}</TableCell>
              <TableCell align="center">
                <Typography variant="body2" color={item.status_id == 1 ? 'success.main' : 'error'}>
                  {item.status}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </Box>
    </>
  );
};

export default EmergencyInfoTable;
